module.exports = __webpack_public_path__ + "static/Target_pin-7058d6711960e13c32434c3f873d98f9.png";